const FEATURE_TABLE_HIGHLIGHT_EDITION_EVENT = "edition-highlight";
const FEATURE_TABLE_HIGHLIGHT_EDITION_CLS_PREFIX = `${FEATURE_TABLE_HIGHLIGHT_EDITION_EVENT}-`;
const FEATURE_TABLE_HIGHLIGHT_BORDER_RIGHT_CLS = `${FEATURE_TABLE_HIGHLIGHT_EDITION_EVENT}-border-right`;

const doHighlight = (
  featureComparisonTable,
  editionNames,
  editionNameToHighlight
) => {
  // remove any current edition highlight class from table
  featureComparisonTable.classList.remove(
    ...editionNames.map(
      (editionName) =>
        `${FEATURE_TABLE_HIGHLIGHT_EDITION_CLS_PREFIX}${editionName}`
    )
  );

  // remove classes added to ensure correct border highlight
  featureComparisonTable
    .querySelectorAll(`.${FEATURE_TABLE_HIGHLIGHT_BORDER_RIGHT_CLS}`)
    .forEach((highlightedNode) =>
      highlightedNode.classList.remove(FEATURE_TABLE_HIGHLIGHT_BORDER_RIGHT_CLS)
    );

  // add class to highlight given edition in table
  const highlightCls =
    FEATURE_TABLE_HIGHLIGHT_EDITION_CLS_PREFIX + editionNameToHighlight;
  featureComparisonTable.classList.add(highlightCls);

  // add classes to previous node siblings to ensure correct border
  featureComparisonTable
    .querySelectorAll(`.${highlightCls}`)
    .forEach((highlightedNode) =>
      highlightedNode.previousElementSibling.classList.add(
        FEATURE_TABLE_HIGHLIGHT_BORDER_RIGHT_CLS
      )
    );
};

class FeatureComparisonTable {
  constructor(componentRoot, { editionNames, defaultHighlightedPlan }) {
    const featureComparisonTable = componentRoot.querySelector(
      ".imkt-feature-comparison-table"
    );

    // must be called on load to handle border highlight correctly
    doHighlight(
      featureComparisonTable,
      editionNames,
      defaultHighlightedPlan.length > 0
        ? defaultHighlightedPlan
        : editionNames[0]
    );

    // add/remove classes as necessary when highlighted edition changes
    featureComparisonTable.addEventListener(
      FEATURE_TABLE_HIGHLIGHT_EDITION_EVENT,
      ({ detail: editionNameToHighlight }) =>
        doHighlight(
          featureComparisonTable,
          editionNames,
          editionNameToHighlight
        )
    );
  }
}

export default FeatureComparisonTable;
